module.exports = __webpack_public_path__ + "static/media/24.d3ca9abe.jpg";